import React from 'react';
import { useTranslation } from 'react-i18next';

import Table from '@/components/ui/tables/Table';
import { FilterDropdown } from '@/components/ui/filters/FilterDropdown';
import { PrimaryButton } from '@/components/ui/buttons/PrimaryButton';
import { PermissionGuard } from '@/components/layout';
import { useSecurityGroupingList } from '@/hooks/securityGrouping';


export const GroupingsTab: React.FC = () => {
  const { t: translate } = useTranslation();
  const {
    rows,
    total,
    page,
    pageSize,
    setPage,
    setPageSize,
    filters,
    setFilters,
    filterConfig,
    columns,
    actions,
    onSearch,
    onSortChange,
    loading,
    openCreatePanel,
  } = useSecurityGroupingList();

  return (
    <div className="flex flex-col gap-6" data-testid="groupings-tab">
      <PermissionGuard action="create" fallback="disabled">
        <div className="w-fit">
          <PrimaryButton onClick={openCreatePanel}>
            {translate('securityGrouping:actions.create')}
          </PrimaryButton>
        </div>
      </PermissionGuard>

      <div className="flex flex-wrap items-center gap-4">
        <FilterDropdown
          filters={filterConfig}
          values={{
            status: filters.status,
          }}
          onChangeFilter={(key, value) => {
            setFilters((previous) => ({
              ...previous,
              [key]: value,
            }));
          }}
        />
      </div>

      <Table
        columns={columns}
        actions={actions}
        data={rows}
        totalRows={total}
        searchable
        onSearch={onSearch}
        onSortChange={onSortChange}
        serverSideSort
        columnMaxWidth={150}
        pagination={{
          page,
          pageSize,
          total,
          onChange: setPage,
          onPageSizeChange: setPageSize,
        }}
        data-testid="groupings-table"
        isLoading={loading}
      />
    </div>
  );
};

export default GroupingsTab;
